package org.hs_soft.runmynesto.pages.components.grid_function

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.BackgroundClip
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.overflowY
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundClip
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.pages.components.LoadingProgress
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.CSSUnitLength
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Composable
fun GridFunction(
    modifier: Modifier = Modifier,
    title: String,
    showFooter:Boolean=true,
    loading:Boolean=false,
    showAddItemIcon:Boolean=false,
    infoTitle: String,
    footerTitle: String,
    fillMaxWidth:Boolean=false,
    showRefreshIcon:Boolean=true,
    titleDescending: Boolean=false,
    numberDescending: Boolean=false,
    showNumberSortIcon: Boolean=false,
    showTitleSortIcon: Boolean=false,
    width: CSSSizeValue<out CSSUnitLength> = Dimen.gridWidth,
    infoList: List<dynamic>,
    onTitleSortClick: () -> Unit={},
    onNumberSortClick: () -> Unit = {},
    onAddItemClick:()->Unit={},
    refreshList: () -> Unit={},
    content: @Composable () -> Unit,
)
{
    Box(
       modifier=Modifier
           .fillMaxHeight()
            .width(width)
            .thenIf(
                fillMaxWidth,
                modifier.fillMaxWidth()
            )
    )
    {
        Column(
            modifier = modifier
                .backgroundClip(BackgroundClip.BorderBox)
                .styleModifier {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                }
                .borderRadius(Dimen.semiLargeRadius)
                .border(
                    width= Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.ActionDisabledBackground.rgb
                )
                .fillMaxWidth()
                .fillMaxHeight()
        )
        {

            GridHeader(
                title=title,
                infoTitle=infoTitle,
                titleDescending = titleDescending,
                numberDescending = numberDescending,
                showNumberSortIcon = showNumberSortIcon,
                showTitleSortIcon = showTitleSortIcon,
                showAddItemIcon = showAddItemIcon,
                onAddItemClick = {
                    onAddItemClick()
                },
                onTitleSortClick={
                    onTitleSortClick()
                },
                onNumberSortClick={
                    onNumberSortClick()
                },
            )


            Box(
                modifier=
                VerticalScrollBehavior
                    .toModifier()
                    .height(0.px)
                    .styleModifier {
                        flexGrow(1)
                        overflowY(Overflow.Auto)
                        display(DisplayStyle.Flex)
                    }
                    .fillMaxWidth()

            ) {
                content()
            }

            if (showFooter){
                GridFooter(
                    title =footerTitle,
                    width = null,
                    dataSize = infoList.size,
                    showRefreshIcon = showRefreshIcon,
                    onRefreshClick = {
                        refreshList()
                    }
                )
            }


        }

        LoadingProgress(
            modifier=Modifier.fillMaxSize(),
            fillAll = false,
            visibility =loading,
        )
    }


}





